"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaQuery = exports.scrollIntoView = exports.calcSpace = exports.isIE11 = exports.cn = void 0;
var system_1 = require("../system");
function merge(classes1, classes2) {
    var reducer = function (obj, key) {
        obj[key] = classes1[key];
        return obj;
    };
    var result = Object.keys(classes1 || {}).reduce(reducer, {});
    var iterator = function (key) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        result[key] = (0, exports.cn)(result[key], classes2[key]);
    };
    Object.keys(classes2 || {}).forEach(iterator);
    return result;
}
exports.cn = Object.assign(function cn() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(' ');
}, {
    merge: merge,
});
function isIE11() {
    return (!!global.window &&
        !!window.MSInputMethodContext &&
        !!document.documentMode);
}
exports.isIE11 = isIE11;
function getSpaceUnit(val) {
    return val === 'XS'
        ? system_1.Spacing.XS
        : val === 'S'
            ? system_1.Spacing.S
            : val === 'M'
                ? system_1.Spacing.M
                : val === 'L'
                    ? system_1.Spacing.L
                    : val === 'XL'
                        ? system_1.Spacing.XL
                        : system_1.Spacing.None;
}
// val format "<number>_<spacing unit>" or "<spacing unit>"
function calcSpace(val) {
    var arr = val.split('_');
    if (arr.length === 1) {
        var unit_1 = getSpaceUnit(arr[0].toUpperCase());
        return unit_1 ? "".concat(unit_1, "px") : arr[0];
    }
    if (arr.length !== 2 || !arr[0] || !arr[1]) {
        return val;
    }
    var k = Number(arr[0]);
    if (Number.isNaN(k)) {
        return val;
    }
    var unitStr = arr[1].toUpperCase();
    var unit = getSpaceUnit(unitStr);
    if (!unit) {
        return val;
    }
    return "".concat(k * unit, "px");
}
exports.calcSpace = calcSpace;
// стандартный scrollIntoView двигает страницу целиком
function scrollIntoView(el) {
    var container = el.parentElement;
    while (!!container && container.scrollHeight - container.offsetHeight < el.offsetHeight) {
        container = container.parentElement;
    }
    if (container) {
        container.scrollTop = Math.abs(container.getBoundingClientRect().top - el.getBoundingClientRect().top);
    }
}
exports.scrollIntoView = scrollIntoView;
__exportStar(require("./dateTime"), exports);
__exportStar(require("./colors"), exports);
var core_1 = require("@material-ui/core");
Object.defineProperty(exports, "useMediaQuery", { enumerable: true, get: function () { return core_1.useMediaQuery; } });
